import { Skeleton } from "@mui/material";

import { useEpcSummaryQuery } from "legacyNext/hooks";

import { S } from "./epc-classification.styles";
import { EPCChip } from "./EPCChip";

type Props = {
    assetExternalId: string;
};

export const EPCClassification = (props: Props) => {
    const { assetExternalId } = props;
    const { data, loading } = useEpcSummaryQuery(assetExternalId);

    if (loading) {
        return <Skeleton variant="text" sx={{ width: "100%" }} />;
    }

    const classifications = Array.from(
        new Set(data.flatMap((summary) => summary.classification || []))
    );

    return (
        <S.List>
            {classifications.map((classification) => (
                <EPCChip key={classification} classification={classification} />
            ))}
        </S.List>
    );
};
